export const AppStoreUrl = 'https://itunes.apple.com/cn/app/id1447998557?mt=8';

export const TenYingStoreUrl = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.kswz.yojiang';

export const APKDownloadUrl = 'https://alcdn.yojiang.cn/apks/3.0.0.0.apk';
// export const APKDownloadUrl = 'https://www.pgyer.com/yojiangDebug';
// https://www.pgyer.com/yojiangDebug （测试开发包）

export const WX_SHARE_DEFAULT_DATA = {
  title: '学技能，上有讲！', // 分享标题
  desc: '分享你一个链接，集合好多的知识和技能，体验到一把学到满足的感觉，真香~', // 分享描述
  link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
  imgUrl: 'https://img.yojiang.cn/classroom/logo.png', // 分享图标
  type: '', // 分享类型,music、video或link，不填默认为link
  dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
};

export const COMMENT_OBJECY_TYPE = {
  content: 77,
  discuss: 91,
};
